export const translations = {
  it: {
    "app.name": "Agorà",
    "app.tagline": "La voce dei cittadini ai governanti",
    "nav.home": "Home",
    "nav.countries": "Paesi",
    "nav.registry": "Verifica Registro",
    "nav.profile": "Profilo",
    "nav.committee": "Comitato",
    "nav.admin": "Admin",
    "nav.login": "Accedi",
    "nav.logout": "Esci",
    "nav.register": "Registrati",
    "common.loading": "Caricamento…",
    "common.save": "Salva",
    "common.cancel": "Annulla",
    "common.create": "Crea",
    "common.back": "Indietro",
    "common.votes": "voti",
    "common.category": "Categoria",
    "common.country": "Paese",
    "common.all": "Tutti",
    "common.close": "Chiudi",
    "status.active": "In corso",
    "status.closed": "Chiuso",
    "status.scheduled": "Programmato",
    "status.pending": "In attesa",
    "status.verified": "Verificato",
    "status.rejected": "Respinto",
    "home.hero.title": "Esprimi la tua posizione. Rendila verificabile.",
    "home.hero.subtitle": "Agorà è la piattaforma civica dove i cittadini votano sui quesiti dei Comitati Indipendenti. Risultati pubblici, aggregati e a prova di manomissione.",
    "home.hero.cta": "Vedi i quesiti attivi",
    "home.hero.cta2": "Come funziona",
    "home.active": "Quesiti attivi",
    "home.stats.questions": "Quesiti",
    "home.stats.votes": "Voti registrati",
    "home.stats.citizens": "Cittadini verificati",
    "home.stats.countries": "Paesi",
    "home.filter.country": "Filtra per paese",
    "home.empty": "Nessun quesito trovato.",
    "q.source": "Fonte",
    "q.opens": "Apertura",
    "q.closes": "Chiusura",
    "q.vote": "Vota",
    "q.voted": "Hai votato",
    "q.results": "Risultati",
    "q.select": "Seleziona un'opzione",
    "q.confirm": "Conferma voto",
    "q.mustVerify": "Devi avere un account verificato per votare.",
    "q.mustLogin": "Accedi per votare.",
    "q.closedMsg": "Le votazioni per questo quesito sono chiuse.",
    "q.voteSuccess": "Voto registrato nella catena in modo sicuro.",
    "q.total": "Totale voti",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Nome completo",
    "auth.country": "Paese di cittadinanza",
    "auth.docNumber": "Numero documento d'identità",
    "auth.doc": "Documento d'identità (immagine/PDF)",
    "auth.loginTitle": "Accedi ad Agorà",
    "auth.registerTitle": "Crea il tuo account",
    "auth.haveAccount": "Hai già un account?",
    "auth.noAccount": "Non hai un account?",
    "auth.registerNote": "Dopo la registrazione un amministratore verificherà la tua identità prima che tu possa votare.",
    "profile.title": "Il tuo profilo",
    "profile.status": "Stato verifica",
    "profile.uploadDoc": "Carica documento d'identità",
    "profile.docUploaded": "Documento caricato — in attesa di verifica.",
    "profile.history": "Storico voti",
    "profile.noVotes": "Non hai ancora votato.",
    "profile.notifPrefs": "Impostazioni notifiche",
    "profile.notifNew": "Nuovo quesito nel mio paese",
    "profile.notifClose": "Promemoria 24h prima della chiusura",
    "profile.notifications": "Notifiche",
    "profile.markAllRead": "Segna tutte come lette",
    "profile.noNotif": "Nessuna notifica.",
    "notif.new_question": "Nuovo quesito nel tuo paese",
    "notif.verification_verified": "Il tuo account è stato verificato! Ora puoi votare.",
    "notif.verification_rejected": "La verifica del tuo account è stata respinta.",
    "notif.verification_pending": "Il tuo account è di nuovo in attesa di verifica.",
    "committee.title": "Pannello Comitato",
    "committee.new": "Nuovo quesito",
    "committee.myQuestions": "Quesiti pubblicati",
    "committee.form.title": "Titolo",
    "committee.form.desc": "Descrizione",
    "committee.form.source": "Link fonte (opzionale)",
    "committee.form.options": "Opzioni di risposta (una per riga)",
    "committee.form.opens": "Data apertura",
    "committee.form.closes": "Data chiusura",
    "committee.created": "Quesito creato e cittadini notificati.",
    "admin.title": "Pannello Amministratore",
    "admin.verify": "Verifica identità",
    "admin.countries": "Paesi",
    "admin.committees": "Comitati",
    "admin.doc": "Documento",
    "admin.viewDoc": "Vedi documento",
    "admin.noDoc": "Nessun documento",
    "admin.approve": "Approva",
    "admin.reject": "Respingi",
    "admin.role": "Ruolo",
    "admin.addCountry": "Aggiungi paese",
    "admin.addCommittee": "Aggiungi comitato",
    "admin.verified": "Stato aggiornato.",
    "registry.title": "Verifica Registro Pubblico",
    "registry.subtitle": "Ogni voto è concatenato al precedente tramite hash SHA-256, come una blockchain. Nessun dato personale è presente: solo hash e conteggi. Verifica tu stesso l'integrità della catena.",
    "registry.verifyBtn": "Verifica integrità catena",
    "registry.valid": "Catena integra e verificata",
    "registry.invalid": "Anomalia rilevata nella catena",
    "registry.records": "record",
    "registry.head": "Hash di testa",
    "registry.index": "Indice",
    "registry.prevHash": "Hash precedente",
    "registry.hash": "Hash",
    "registry.time": "Orario",
    "countries.title": "Paesi",
    "countries.subtitle": "Seleziona un paese per vedere comitati, quesiti e statistiche.",
    "country.committees": "Comitati indipendenti",
    "country.questions": "Quesiti",
    "install.text": "Installa Agorà sul tuo dispositivo",
    "install.btn": "Installa",
  },
  en: {
    "app.name": "Agorà",
    "app.tagline": "Citizens' voice to their leaders",
    "nav.home": "Home",
    "nav.countries": "Countries",
    "nav.registry": "Verify Ledger",
    "nav.profile": "Profile",
    "nav.committee": "Committee",
    "nav.admin": "Admin",
    "nav.login": "Sign in",
    "nav.logout": "Sign out",
    "nav.register": "Sign up",
    "common.loading": "Loading…",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.create": "Create",
    "common.back": "Back",
    "common.votes": "votes",
    "common.category": "Category",
    "common.country": "Country",
    "common.all": "All",
    "common.close": "Close",
    "status.active": "Open",
    "status.closed": "Closed",
    "status.scheduled": "Scheduled",
    "status.pending": "Pending",
    "status.verified": "Verified",
    "status.rejected": "Rejected",
    "home.hero.title": "Voice your stance. Make it verifiable.",
    "home.hero.subtitle": "Agorà is the civic platform where citizens vote on questions from Independent Committees. Public, aggregated and tamper-proof results.",
    "home.hero.cta": "See active questions",
    "home.hero.cta2": "How it works",
    "home.active": "Active questions",
    "home.stats.questions": "Questions",
    "home.stats.votes": "Recorded votes",
    "home.stats.citizens": "Verified citizens",
    "home.stats.countries": "Countries",
    "home.filter.country": "Filter by country",
    "home.empty": "No questions found.",
    "q.source": "Source",
    "q.opens": "Opens",
    "q.closes": "Closes",
    "q.vote": "Vote",
    "q.voted": "You voted",
    "q.results": "Results",
    "q.select": "Select an option",
    "q.confirm": "Confirm vote",
    "q.mustVerify": "You need a verified account to vote.",
    "q.mustLogin": "Sign in to vote.",
    "q.closedMsg": "Voting for this question is closed.",
    "q.voteSuccess": "Vote securely recorded in the chain.",
    "q.total": "Total votes",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Full name",
    "auth.country": "Country of citizenship",
    "auth.docNumber": "ID document number",
    "auth.doc": "ID document (image/PDF)",
    "auth.loginTitle": "Sign in to Agorà",
    "auth.registerTitle": "Create your account",
    "auth.haveAccount": "Already have an account?",
    "auth.noAccount": "Don't have an account?",
    "auth.registerNote": "After registration an admin will verify your identity before you can vote.",
    "profile.title": "Your profile",
    "profile.status": "Verification status",
    "profile.uploadDoc": "Upload ID document",
    "profile.docUploaded": "Document uploaded — pending verification.",
    "profile.history": "Voting history",
    "profile.noVotes": "You haven't voted yet.",
    "profile.notifPrefs": "Notification settings",
    "profile.notifNew": "New question in my country",
    "profile.notifClose": "Reminder 24h before closing",
    "profile.notifications": "Notifications",
    "profile.markAllRead": "Mark all as read",
    "profile.noNotif": "No notifications.",
    "notif.new_question": "New question in your country",
    "notif.verification_verified": "Your account has been verified! You can now vote.",
    "notif.verification_rejected": "Your account verification was rejected.",
    "notif.verification_pending": "Your account is pending verification again.",
    "committee.title": "Committee Panel",
    "committee.new": "New question",
    "committee.myQuestions": "Published questions",
    "committee.form.title": "Title",
    "committee.form.desc": "Description",
    "committee.form.source": "Source link (optional)",
    "committee.form.options": "Answer options (one per line)",
    "committee.form.opens": "Opening date",
    "committee.form.closes": "Closing date",
    "committee.created": "Question created and citizens notified.",
    "admin.title": "Administrator Panel",
    "admin.verify": "Identity verification",
    "admin.countries": "Countries",
    "admin.committees": "Committees",
    "admin.doc": "Document",
    "admin.viewDoc": "View document",
    "admin.noDoc": "No document",
    "admin.approve": "Approve",
    "admin.reject": "Reject",
    "admin.role": "Role",
    "admin.addCountry": "Add country",
    "admin.addCommittee": "Add committee",
    "admin.verified": "Status updated.",
    "registry.title": "Public Ledger Verification",
    "registry.subtitle": "Each vote is chained to the previous one via SHA-256 hash, like a blockchain. No personal data is present: only hashes and counts. Verify the chain integrity yourself.",
    "registry.verifyBtn": "Verify chain integrity",
    "registry.valid": "Chain intact and verified",
    "registry.invalid": "Anomaly detected in the chain",
    "registry.records": "records",
    "registry.head": "Head hash",
    "registry.index": "Index",
    "registry.prevHash": "Previous hash",
    "registry.hash": "Hash",
    "registry.time": "Time",
    "countries.title": "Countries",
    "countries.subtitle": "Select a country to see committees, questions and statistics.",
    "country.committees": "Independent committees",
    "country.questions": "Questions",
    "install.text": "Install Agorà on your device",
    "install.btn": "Install",
  },
};
